import {motion} from "framer-motion";
import classes from "./footer.module.css";
import telegram from "../../images/telegram.svg";
import po_slovu from "../../images/po_slovu_tvoemu.jpg";
import whatsapp from "../../images/whatsapp.svg";

const po_slovu_group_url = process.env.REACT_APP_TG_PO_SLOVU_GROUP_URL;
const year = new Date().getFullYear();

const Footer = () => {
    return (
        <motion.footer
            className={classes.footer}
            initial={{opacity: 0, y: 24}}
            whileInView={{opacity: 1, y: 0}}
            viewport={{once: true, amount: 0.3}}
            transition={{duration: 0.5, ease: "easeOut"}}
        >
            <div className={`container ${classes.inner}`}>
                <div className={classes.left}>
                    <div className={classes.contact_title}>Контакты</div>
                    <a href="tel:+79615357695" className={classes.contact_link}>
                        +7 (961) 535-76-95
                    </a>
                    <a href="mailto:voteyra@gmail.com" className={classes.contact_link}>
                        voteyra@gmail.com
                    </a>
                </div>

                <div className={classes.right}>
                    <div className={classes.icons}>
                        <a href="https://wa.me/9384831056" target="_blank" rel="noreferrer"
                           className={classes.iconLink} aria-label="WhatsApp">
                            <img src={whatsapp} alt="WhatsApp"/>
                        </a>
                        <a href="https://t.me/voteyra" target="_blank" rel="noreferrer"
                           className={classes.iconLink} aria-label="Telegram">
                            <img src={telegram} alt="Telegram"/>
                        </a>
                        <a href={po_slovu_group_url} target="_blank" rel="noreferrer"
                           className={`${classes.iconLink} ${classes.rounded}`} aria-label="По слову Твоему">
                            <img src={po_slovu} alt="По слову Твоему"/>
                        </a>
                    </div>
                    <div className={classes.signature}>Церковь «Белая Невеста»</div>
                </div>
            </div>

            <div className={classes.copyright}>
                © {year} Церковь «Белая Невеста». Все права защищены.
            </div>
        </motion.footer>
    );
}

export default Footer;
